import React from "react";

export function QuickReplies({
  replies = [],
  onSelect,
  disabled = false,
}) {
  if (!replies.length) return null;

  return (
    <div
      className="flex gap-2 overflow-x-auto px-4 py-2 scrollbar-hidden"
      aria-label="Suggested replies"
    >
      {replies.map((reply) => (
        <button
          key={reply.id}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(reply.value)}
          className="shrink-0 rounded-full border border-[#0A4730]/20 bg-white px-3.5 py-2 text-[12px] font-semibold text-[#0A4730] transition active:scale-95 disabled:opacity-50"
        >
          {reply.label}
        </button>
      ))}
    </div>
  );
}